export default {
  text: '#333333',
  primary: '#0073a6',
  secondary: '#d32029',
  background: '#fdfdfd',
  backgroundSecondary: '#fff',
  light: '#FFF',
  dark: '#333333'
}
